import React from "react";
import { Link } from "react-router-dom";
import heroImage from "../assets/images/hero-bg.webp";
import "./HeroSection.css";

export default function HeroSection() {
  return (
    <section className="ceymos-hero" aria-labelledby="hero-heading">
      <img className="ceymos-hero-image" src={heroImage} alt="" fetchPriority="high" />
      <div className="ceymos-hero-content">
        <p className="ceymos-eyebrow">Rooted in Sri Lanka. Shared with the world.</p>
        <h1 id="hero-heading">A little island.<br />An extraordinary <em>taste.</em></h1>
        <p className="ceymos-hero-description">Discover Ceylon tea, fragrant spices, coconut essentials and traditional rice. The flavors of our home, brought to yours.</p>
        <div className="ceymos-hero-actions">
          <Link className="ceymos-button" to="/products">Explore our products <span aria-hidden="true">↗</span></Link>
          <Link className="ceymos-text-link" to="/contact">Let's talk exports <span aria-hidden="true">→</span></Link>
        </div>
      </div>
      <div className="ceymos-hero-bottom"><span>CEYLON ORIGINS · GLOBAL CONNECTIONS</span><a href="#our-collection">Discover our collection ↓</a></div>
    </section>
  );
}
